import config from '../config';

const _storage = localStorage;
const _identifier = config.auth.AUTH_TOKEN_STORAGE_IDENTIFIER;

/**
 * Class TokenStorageService
 */
export default {

    /**
     * Stores the authorization token
     *
     * @param {string} token
     * @returns { void }
     */
    set (token) {
        _storage.setItem(_identifier, token);
    },

    /**
     * Retrieves the authorization token from storage
     *
     * @returns {string | null}
     */
    get () {
        return _storage.getItem(_identifier);
    },

    /**
     * Removes the authorization token from storage
     *
     * @returns { void }
     */
    del () {
        return _storage.removeItem(_identifier);
    }
}



// WEBPACK FOOTER //
// ./src/services/TokenStorageService.js